import React, { useEffect, useState, useRef } from "react";
import { FaPlus } from "react-icons/fa";
import "./AdminHoliday.css";
import AddHoliday from "../AdminComponent/AddHoliday";

import { format } from 'date-fns';
import MainLayout from "../../../layouts/MainLayout";
import { useDispatch } from "react-redux";
import { getHolidayData } from "../../../redux/actions/employeeActions";
import { useSelector } from "react-redux";

const AdminHoliday = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const currentDate = format(new Date(), 'yyyy-MM-dd');
  const dispatch = useDispatch()
  const holidayData = useSelector((state) => state.employeeData?.holidayList)
  const isLoading = useSelector((state) => state.employeeData?.loading)
  const profileData = useSelector((state) => state.employeeData?.profile)
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {};

  useEffect(() => {
    dispatch(getHolidayData())
  }, []);

  // //console.log("profileData", profileData ,userDetails?.user?.type);


  const handleClick = () => {
    setModalOpen(true);
  };
  const getOpcity = (data) => {
    if (data?.date < currentDate) {
      return 0.5;
    } else {
      return 1;
    }
  };
  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="content">
          {
            isLoading ? "Loading..." :
              <div className="holidayDiv">
                {
                  profileData?.type == "Admin" && userDetails?.user?.type == "Admin" &&
                  <div className="crow2">
                    <div className="crow3">
                      <h1 style={{ fontWeight: "700", fontSize: 30, color: "black" }}>
                        Holidays({holidayData[0]?.year})
                      </h1>
                    </div>
                    <div className="button-container1">
                      <button className="btn btn-primary d-flex gap-1 align-items-center" onClick={handleClick}>
                        <FaPlus />
                        Add Holiday
                      </button>
                    </div>
                  </div>
                }
                <div className="card-container12 text-start">
                  <div
                    style={{
                      marginBottom: 20,

                      flexDirection: "row",
                      display: "flex",
                    }}
                  >
                    <h1 style={{ color: "#155596", fontWeight: "700", fontSize: 25 }}>
                      Holiday Details
                    </h1>
                  </div>
                  <div className="holiday-list">
                    {holidayData?.map((holiday, index) => (
                      <div key={index} className="holiday-item">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            background: "white",
                            width: 70,
                            height: 58,
                            borderWidth: 2,
                            opacity: getOpcity(holiday),
                            borderRadius: 2,
                            borderColor: "#047EFF",
                          }}
                        >
                          <div className="holiday-date">
                            <div className="holiday-month">
                              {holiday?.month.slice(0, 3)}
                            </div>
                          </div>
                          <div className="holiday-day">{holiday?.date.split("-")[2]}</div>
                        </div>

                        <div className="holiday-details">
                          <div className="holiday-name">{holiday.holiday_name}</div>
                          <div className="holiday-weekday">{holiday.day}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
                <AddHoliday open={modalOpen} onClose={() => setModalOpen(false)} />
              </div>

          }
        </div>
      </div>
    </MainLayout>
  );
};

export default AdminHoliday;
